// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__21MJf","error":"Textarea_error__2Hnq_","readonly":"Textarea_readonly__2XT3E","disabled":"Textarea_disabled__2MZjq"};